import _extends from '@babel/runtime-corejs3/helpers/extends';
import _objectWithoutProperties from '@babel/runtime-corejs3/helpers/objectWithoutProperties';
import React__default from 'react';
import classNames from 'classnames';
import styles from './ad9511886054193cba05064cfab0382a17fe5fe87409dfd4e0f1420b3114f700.cfe-internal.js';
import Check from './93f39b3c40220dbc6104f229c1d43ecffa8f6caba93d85987e106057eb967c87.cfe-internal.js';
import { useFormFieldContext } from '../FormField/f390dafefe74ba07f7da711a77443b7b51d96a6ad1aee47361fd1804064e9ba7.cfe-internal.js';
import '../../utils/2d829def7915df1f35176a057ded5c77071616520fe7b6b8ef66f5eb29ca849f.cfe-internal.js';
import concatIds from '../../utils/concatIds/99a67648a55cf7a2ee84ef14be5ebb23af1b4b19b5520388cd5eef8f3f3a1e28.cfe-internal.js';

var _excluded = ["id", "className", "checked", "defaultChecked", "disabled", "onChange", "value", "name", "inputProps", "aria-label", "aria-labelledby", "aria-describedby"];
var Checkbox = /*#__PURE__*/React__default.forwardRef(function (_ref, ref) {
  var id = _ref.id,
    className = _ref.className,
    checked = _ref.checked,
    defaultChecked = _ref.defaultChecked,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    onChange = _ref.onChange,
    value = _ref.value,
    name = _ref.name,
    inputProps = _ref.inputProps,
    externalAriaLabel = _ref['aria-label'],
    externalAriaLabelledBy = _ref['aria-labelledby'],
    externalAriaDescribedBy = _ref['aria-describedby'],
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useFormFieldContext = useFormFieldContext(),
    formFieldHelperTextId = _useFormFieldContext.helperTextId,
    formFieldErrorTextId = _useFormFieldContext.errorTextId;
  var internalAriaDescribedby = concatIds(externalAriaDescribedBy, formFieldHelperTextId, formFieldErrorTextId, inputProps === null || inputProps === void 0 ? void 0 : inputProps['aria-describedby']);
  return /*#__PURE__*/React__default.createElement("span", _extends({}, rest, {
    ref: ref,
    className: classNames(className, styles.checkbox)
  }), /*#__PURE__*/React__default.createElement("input", _extends({}, inputProps, {
    name: name !== null && name !== void 0 ? name : inputProps === null || inputProps === void 0 ? void 0 : inputProps.name,
    className: classNames(styles.input, inputProps === null || inputProps === void 0 ? void 0 : inputProps.className),
    type: "checkbox",
    id: id !== null && id !== void 0 ? id : inputProps === null || inputProps === void 0 ? void 0 : inputProps.id,
    checked: checked !== null && checked !== void 0 ? checked : inputProps === null || inputProps === void 0 ? void 0 : inputProps.checked,
    defaultChecked: defaultChecked !== null && defaultChecked !== void 0 ? defaultChecked : inputProps === null || inputProps === void 0 ? void 0 : inputProps.defaultChecked,
    disabled: disabled !== null && disabled !== void 0 ? disabled : inputProps === null || inputProps === void 0 ? void 0 : inputProps.disabled,
    onChange: disabled ? undefined : onChange !== null && onChange !== void 0 ? onChange : inputProps === null || inputProps === void 0 ? void 0 : inputProps.onChange,
    value: value !== null && value !== void 0 ? value : inputProps === null || inputProps === void 0 ? void 0 : inputProps.value,
    "aria-label": externalAriaLabel !== null && externalAriaLabel !== void 0 ? externalAriaLabel : inputProps === null || inputProps === void 0 ? void 0 : inputProps['aria-label'],
    "aria-labelledby": externalAriaLabelledBy !== null && externalAriaLabelledBy !== void 0 ? externalAriaLabelledBy : inputProps === null || inputProps === void 0 ? void 0 : inputProps['aria-labelledby'],
    "aria-describedby": internalAriaDescribedby
  })), /*#__PURE__*/React__default.createElement("span", {
    className: styles.check
  }, /*#__PURE__*/React__default.createElement(Check, {
    className: styles.checkIcon
  })));
});

export { Checkbox as default };
